const layout = 'redesign';

const formatRoutes = (routes = [], breadcrumbs = true, backControl = true) => routes.map((route) => {
  const meta = route.meta || {};
  return {
    ...route,
    meta: {
      ...meta,
      navigation: {
        breadcrumbs,
        back: meta.navigation?.back ?? backControl,
      },
      layout,
    },
    children: (route.children || []).map((child) => ({
      ...child,
      meta: {
        ...meta,
        ...child.meta,
        layout,
      },
    })),
  };
});

export default formatRoutes;
